import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDemoImportPayload } from '@app-store/slices/demos/import'

interface TaskAction extends Action {
    payload: IDemoImportPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.demos.import

function* demoImportSagaTask({ payload }) {
    try {
        const response = yield axios.post(`/companies/demos/import`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        // console.log(error)
        yield put(onFailure(error))
    }
}

function* demoImportSaga(): any {
    yield takeLatest<TaskAction>(onRequest, demoImportSagaTask)
}

export default demoImportSaga
